import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MainLayout from "../../Layout/mainLayout";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addNewState, viewCountry } from "../../Redux/Actions/settingsActions";
import toast from "react-hot-toast";
import TextInput from "../../Global Functions/textInput";

const AddState = () => {
  const { id } = useParams();

  const [stateData, setStateData] = useState({
    state_name: "",
    country: id,
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { country } = useSelector((state) => state.country);

  useEffect(() => {
    dispatch(viewCountry(id));
  }, [id, dispatch]);

  const handleSubmit = (event) => {
    try {
      event.preventDefault();
      if (!stateData.state_name) {
        return toast.error("Input Fields cannot be empty");
      }
      dispatch(addNewState(stateData));

      setStateData({ state_name: "" });
    } catch (error) {
      console.error("Error at submitting state", error.message);
    }
  };

  const handleAddChange = (event) => {
    try {
      const { name, value } = event.target;
      setStateData((prevData) => ({ ...prevData, [name]: value }));
    } catch (error) {
      console.error("Error Adding State", error.message);
    }
  };

  return (
    <MainLayout>
      <div className="grid-span-5 border-24 bg-white padding-20" style={{width: "100%"}}>
        <div className="flex-container flex-justify-between">
          <h1>Add State</h1>

          <button onClick={() => navigate(-1)} className="button-class">
            View State List
          </button>
        </div>
        <form>
          <div className="flex-container flex-justify-between ">
            <div style={{ width: "50%" }}>
              <TextInput
                disabled
                name="country"
                label="Country Name"
                value={country?.data?.country_name || "N/A"}
              ></TextInput>
            </div>
            <div style={{ width: "50%" }}>
              <TextInput
                name="state_name"
                onChange={handleAddChange}
                placeholder="Enter Name"
                label="State Name"
                value={stateData.state_name}
              ></TextInput>
            </div>
          </div>
          <div
            className="flex-end padding-20
          "
          >
            <Link to="/state">
              <button className="button-class-white">Cancel</button>
            </Link>
            <button className="button-class" onClick={handleSubmit}>
              Save
            </button>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default AddState;
